// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3s7zL","left":"styles_left__C-T9F"};